import { HardwareItemUnit } from "../enums/hardware-item-unit.enum";

export type C3InventoryStockStatus = 'belowMinimum' | 'nearMinimum' | 'healthy' | 'unconfigured';

export interface C3InventoryThresholdSource {
    qtyOnHand: number;
    minimumStock?: number | null;
    maximumStock?: number | null;
}

export interface C3InventoryThresholdReport {
    id: string;
    reportId: string;
    belowMinimumCount: number;
    nearMinimumCount: number;
    healthyCount: number;
    configuredItemCount: number;
    unconfiguredItemCount: number;
    notifiedOn: Date | null;
    notificationUserIds: string[];
}

export interface C3InventoryThresholdReportItem {
    id: string;
    reportId: string;
    hardwareItemId: string;
    partNumber: string;
    description: string;
    qtyOnHand: number;
    units: HardwareItemUnit;
    minimumStock: number | null;
    maximumStock: number | null;
    stockStatus: C3InventoryStockStatus;
    suggestedOrderQuantity: number;
    vendorId: string;
    vendorName: string;
    vendorSku: string;
    vendorDescription: string;
}

export function getC3InventoryStockStatus(source: C3InventoryThresholdSource): C3InventoryStockStatus {
    const qtyOnHand = Number(source.qtyOnHand ?? 0);
    const minimumStock = source.minimumStock;
    const maximumStock = source.maximumStock;

    if (minimumStock == null || maximumStock == null) {
        return 'unconfigured';
    }

    if (qtyOnHand < minimumStock) {
        return 'belowMinimum';
    }

    const warningBand = Math.max(1, Math.ceil((maximumStock - minimumStock) * 0.2));
    return qtyOnHand <= minimumStock + warningBand ? 'nearMinimum' : 'healthy';
}

export function getC3SuggestedOrderQuantity(source: C3InventoryThresholdSource): number {
    return source.maximumStock == null ? 0 : Math.max(0, Math.ceil(source.maximumStock - Number(source.qtyOnHand ?? 0)));
}
